<template>
  <div class="setting-drawer" ref="settingDrawer" v-if="is_show">
    <a-drawer
      width="400"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
      :getContainer="() => $refs.settingDrawer"
      :style="{}"
    >
      <div class="setting-drawer-index-content">
        <!-- <iframe class="iframe" :src="get_url ? get_url : 'https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97812006c076159ee74ab7e567dce0bcd30498d0ce8ad6c92a6847f91da2b5b256c1aa7a341d2a383dc84e987e38809893'"></iframe> -->
        <img src="../../../assets/qrcode.jpg" alt="" width="100%">
      </div>
      <div class="setting-drawer-index-handle" @click="toggle">
        <div class="text">咨询客服</div>
        <!-- <a-icon type="setting" v-if="!visible"/>
        <a-icon type="close" v-else/>-->
      </div>
    </a-drawer>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visible: true
    }
  },
  computed: {
    is_show() {
      const extend = this.$store.state.brand.extend
      return extend.includes('CustomerServiceDrawer')
    },
    is_customer() {
      const extend = this.$store.state.brand.extend
      return extend.includes('CustomerService')
    },
    get_url() {
      if (this.$store.state.brand.extend.includes('CustomerService')) {
        const data = this.$store.state.brand.extend_data['customerService']
        return data.url
      } else {
        return ''
      }
    }
  },
  watch: {},
  mounted() {
    const vm = this
    setTimeout(() => {
      vm.visible = false
    }, 16)
  },
  methods: {
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    toggle() {
      this.visible = !this.visible
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-body {
  padding: 0;
}
/deep/ .ant-drawer-wrapper-body{
  display: flex;
  align-items: center;
  background: #f2f2f2;
}
.setting-drawer-index-content {

  .iframe {
    border: 0;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .setting-drawer-index-blockChecbox {
    display: flex;

    .setting-drawer-index-item {
      margin-right: 16px;
      position: relative;
      border-radius: 4px;
      cursor: pointer;

      img {
        width: 48px;
      }

      .setting-drawer-index-selectIcon {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        padding-top: 15px;
        padding-left: 24px;
        height: 100%;
        color: #1890ff;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .setting-drawer-theme-color-colorBlock {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    float: left;
    cursor: pointer;
    margin-right: 8px;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
    color: #fff;
    font-weight: 700;

    i {
      font-size: 14px;
    }
  }
}

.setting-drawer-index-handle {
  position: fixed;
  top: 240px;
  background: #1890ff;
  width: 48px;
  height: 48px;
  right: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1001;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
  .text {
    color: #fff;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    width: 28px;
  }
}
</style>
